import React, { ReactElement, ReactNode } from "react";

interface ListSearchBarProps {
  criteria?: ReactNode;
  children: ReactElement;
  onReset: () => void;
  resetLabel: string;
  onSearch?: () => void;
  searchLabel?: string;
}

/** Shared presentation; each list keeps its own filters and loading logic. */
export default function ListSearchBar({ criteria, children, onReset, resetLabel, onSearch, searchLabel }: ListSearchBarProps) {
  return (
    <div className="list-search-bar" role="group">
      {criteria && <div className="list-search-criteria">
        <i className="las la-filter" aria-hidden="true" />
        {criteria}
      </div>}
      <div className="list-search-entry">
        <i className="las la-search" aria-hidden="true" />
        {children}
      </div>
      {onSearch && <button type="button" className="list-search-submit" onClick={onSearch} title={searchLabel} aria-label={searchLabel}>
        <i className="las la-search" aria-hidden="true" />
      </button>}
      <button type="button" className="list-search-reset" onClick={onReset} title={resetLabel} aria-label={resetLabel}
        disabled={children.props.value === ""}>
        <i className="las la-times" aria-hidden="true" />
      </button>
    </div>
  );
}
